// extracted by mini-css-extract-plugin
module.exports = {"btn":"style__btn__YD5Lp"};